<template>
  <v-card class="py-3 px-2" outlined>
    <v-card-title class="light-blue--text headline">{{$props.title}}</v-card-title>
    <v-card-text>

      <template v-if="propertiesLoading">
        <div class="text-center">
          <v-progress-circular color="light-blue" indeterminate/>
        </div>
      </template>
      <template v-else>
        <template v-if="Object.keys(properties).length">
          <template v-for="(property, id, index) in properties">
            <v-row no-gutters :key="'list'+id" align="center" justify="space-between">
              <v-col cols="12" lg="8" class="mb-3 mb-lg-0">
                <div class="d-flex align-self-center">
                  <v-icon small class="mr-1">mdi-account</v-icon> <span>{{property.tenantFirstName}} {{property.tenantLastName}}</span>
                </div>
                <div class=" d-flex"> {{ property.addressLineOne }}, {{ property.city }} {{ property.state }}, {{ property.zip  }}</div>

              </v-col>

              <v-col cols="12" lg="3">
                <v-btn
                  color="light-blue"
                  dark
                  block
                  :small="$vuetify.breakpoint.mdAndUp"
                  elevation="0"
                  tile
                  :to="'/properties/detail/'+id"
                >
                  Manage
                </v-btn>
              </v-col>
            </v-row>
            <v-divider v-if="index !== Object.keys(properties).length -1 && Object.keys(properties).length !== 1" class="my-3" :key="'divider'+id"></v-divider>

          </template>
        </template>
        <template v-else>
          <v-row align="center" justify="space-between">
            <v-col>
              You have no properties added.
            </v-col>
          </v-row>
        </template>
      </template>


    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PropertiesList",

  computed:{
    ...mapGetters(['properties', 'propertiesLoading']),
  },

  props: {
    title: {
      type: String,
      default: 'Properties'
    },
  }
}
</script>

<style scoped>

</style>
